
init_cart();
work_with_return_url();

function init_cart() {
  console.log('checkout init')
    document.addEventListener("submit", function (e) {
      console.log('Submit')      
      var action = e.target.getAttribute('action')
      action = action.split('/')
      action = action[action.length - 1]
      
      console.log(action)

        if (action !== 'cart') return;
        e.preventDefault();
        get_cart_object();
   
    });

    document.addEventListener("click", function (e) {
        if (e.target && e.target.parentNode && e.target.parentNode.getAttribute('href') === '/checkout') {
            e.preventDefault();
            location.href = '/cart';
        }
    });
}

function get_query_params() {
    var params = {};
    var query = window.location.href.split('?')[1];
    if (query) {
        var p1 = query.split('&');
        for (let i = 0; i < p1.length; i++) {
            var p_item = p1[i].split('=');
            params[decodeURIComponent(p_item[0])] = decodeURIComponent(p_item[1]);
        }
    }
    return params;
}

function work_with_return_url() {
    var params = get_query_params();
    if (params['checkout_return_url']) {
        localStorage.setItem('checkout_return_url', encodeURIComponent(params['checkout_return_url']));
        window.location = '/account/login';
    } else {
        var checkout_return_url = localStorage.getItem('checkout_return_url');
        if (!checkout_return_url) return;
        var customer_id = get_customer_id();
        if (!customer_id) return;
        delete localStorage['checkout_return_url'];
        var data = {
            customer_id: customer_id,
        }
        post_to_url(decodeURIComponent(checkout_return_url), data, false);
    }
}

function get_customer_id() {
    return __st ? __st.cid : undefined;
}

function get_cart_object() {
    var data = {
        cookie: document.cookie,
        location: document.location.href,
        items: []
    };

    fetch('/cart.js').then(function (result) {
        result.json().then(function (json) {
            data.cart = json;
            create_request(data);
        });
    });
}

function create_request(data) {
    data.customer_id = get_customer_id();

    var list = document.getElementsByClassName("cart-item")

    for (var i = 1; i < list.length; i++) {
        var element = list[i]
        data.items.push({
            id: element.getAttribute("data-cart-item-key"),
            count: element.getAttribute("data-cart-item-quantity")
        });
    }
	var URL = 'https://checkout.grailshop.ru/api/v1/order/create';
  
  //URL = 'http://localhost:3000/api/v1/order/create';

    post_to_url(URL, data, false);

}


function post_to_url(url, values, new_window) {

    var w = window;
    if (new_window) w = window.open("about:blank");

    w.document.write('Processing...');

    // w.document.title = 'Print';

    var form_data = JSON.stringify(values);
    var params = {
        data: form_data,
        parse_body_data: true
    }

    var form = w.document.createElement('form');
    form.action = url;
  console.log(url)
    form.method = 'POST';
    form.enctype = "application/x-www-form-urlencoded";
    // form.enctype = "multipart/form-data";

    for (var i in params) {
        var input = w.document.createElement('input');
        input.type = 'hidden';
        input.name = i;
        input.value = params[i];
        form.appendChild(input);
    }

    w.document.body.appendChild(form);
    form.submit();
}